function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BCH_svg__clip0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.002 22.392C12.262 25.706 4.924 23.74 1.61 18S.262 4.922 6.002 1.608 19.081.26 22.395 6c3.313 5.74 1.347 13.078-4.393 16.392zM15.93 8.018c-.582-1.48-2.042-1.612-3.741-1.282l-.605-2.11-1.284.368.589 2.055c-.338.096-.68.202-1.022.307l-.592-2.068-1.284.368.605 2.11c-.277.085-.549.17-.815.245l-.002-.007-1.772.508.394 1.371s.943-.29.933-.268c.52-.149.775.105.9.352l.69 2.403c.035-.01.082-.022.138-.03l-.136.039.965 3.367c.024.17.003.459-.36.564.02.01-.934.268-.934.268l.184 1.606 1.672-.48c.311-.088.619-.17.919-.254l.612 2.133 1.284-.368-.606-2.11c.355-.095.696-.19 1.03-.285l.601 2.102 1.284-.37-.61-2.129c2.124-.743 3.479-1.72 3.085-3.801-.317-1.676-1.294-2.185-2.604-2.128.637-.592.91-1.394.482-2.476zm-.489 5.078c.46 1.595-2.324 2.196-3.195 2.447l-.81-2.828c.872-.25 3.529-1.282 4.005.381zM13.7 9.28c.415 1.45-1.91 1.934-2.635 2.142l-.735-2.564c.724-.208 2.935-1.092 3.37.422z",
  fill: "#8DC351"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BCH_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

function SvgBch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "7c6c9ddf0ccea3f2edf7d3f0f0ad045a.svg";
export { SvgBch as ReactComponent };